import LazyLoad from "react-lazyload";

import dynamic from "next/dynamic";

import { classNames } from "common/functions";
import {
  AutoConvertPriceWithUnit,
  convertPriceOnString,
} from "common/priceConvert";

import ButtonNew from "components/atoms/ButtonNew/index";
import { FaCheck } from "components/atoms/Icon/fa/FaCheck";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import stylePackage from "components/molecules/CardPackage/Index.module.scss";
import FormCountries from "components/molecules/FormCountries";
import RefundGuarantee from "components/molecules/RefundGuarantee";
import Banner from "components/organisms/Banner/index.js";
import Faqs from "components/organisms/Faqs";

const NewsSlider = dynamic(() => import("components/organisms/NewsSlider"), {
  ssr: false,
});
/** ========== */

const ImmigrationService = ({ dataJson, data }) => {
  return (
    <>
      <Banner
        minHeightBanner=" banner-fix-min-h-569 "
        wave={
          <div className="col-12 absolute bottom-0 hidden lg:block ">
            <Img
              src="/assets/images/wave/curve_top-wave.svg"
              className="h-full w-full"
              width={516}
              wrapper={{
                className: "w-full h-full",
              }}
              height={420}
              alt="banner-img"
            />
          </div>
        }
        breadcrumbs={dataJson?.breadcrumbs}
        title="Become an expat in Singapore"
        titleProps={{
          className: "banner-default-title mb-6 lg:mb-0 capitalize",
          textColor: "banner-title-default-color",
        }}
        leftClassName="lg:col-6"
        rightClassName="lg:col-5 lg:ml-[65px]"
        rightContent={
          <Img
            src="/assets/images/sg/immigration-service/banner-sg-immigration.png"
            wrapper={{
              className: "bbc-banner-image-country",
            }}
            className=" w-full"
            width={542}
            height={389}
            alt="visa and immigration services in Singapore"
          />
        }
        bgColor="bg-wmud"
      ></Banner>
      <div className="bg-bbc-brand-100">
        {" "}
        <div className="pt-10 lg:pt-20 ">
          <div className="container">
            <Title className="title-h2 mb-6 text-center font-semibold text-bbc-brand-800">
              Our Services
            </Title>
            <p className="mb-6 text-center lg:mb-10">
              Application for a work pass in Singapore is an ideal option for
              foreigners who wish to register business and at the same time
              relocate to the country to manage their company. Work Pass is also
              a must should a local company want to hire foreign professionals.
              Moreover, Work Pass holders are allowed to carry their close
              relatives with them by applying for Dependant’s Pass.
            </p>
            <div className="row justify-center">
              <div className="mb-6 lg:col-4 lg:mb-0">
                <div className=" group flex h-full flex-col justify-between rounded-3xl border-0  border-transparent bg-white ring-1 ring-neutral-200 transition-all duration-200 lg:border-4 lg:hover:border-4 lg:hover:border-bbc-primary lg:hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]">
                  <div className="border-b border-b-bbc-neutral-500 px-5 pt-[29px] pb-8 text-center ">
                    <p className="mb-8 text-[32px] font-semibold capitalize leading-[42px] tracking-[0.25px] text-bbc-primary">
                      Employment Pass
                    </p>
                    <p className="text-[50px] font-semibold leading-[54px] tracking-[0.25px] text-bbc-primary">
                      {AutoConvertPriceWithUnit(800, 1)}
                    </p>
                  </div>
                  <ul className="flex-1  py-8 px-8">
                    <li className="relative mt-2 list-none">
                      <FaCheck
                        className="absolute top-1.5 left-0 text-bbc-brand-500"
                        size={12}
                      />
                      <span className="inline-block pl-7 ">
                        For those who wish to move to Singapore
                      </span>
                    </li>
                  </ul>

                  <div className="border-t border-t-bbc-neutral-500 px-5 pt-8 pb-11 text-center">
                    <ButtonNew
                      as="a"
                      href="/onboarding/register"
                      othersClass={`${classNames(
                        stylePackage.btnAnimate,
                        stylePackage.btnBlue
                      )} w-full font-normal font-medium `}
                    >
                      <span>Get Started</span>
                    </ButtonNew>
                  </div>
                </div>
              </div>
              <div className="lg:col-4">
                <div className=" group flex h-full flex-col justify-between rounded-3xl border-0  border-transparent bg-white ring-1 ring-neutral-200 transition-all duration-200 lg:border-4 lg:hover:border-4 lg:hover:border-bbc-brand-700 lg:hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]">
                  <div className="border-b border-b-bbc-neutral-500 px-5 pt-[29px] pb-8 text-center ">
                    <p className="mb-8 text-[32px] font-semibold capitalize leading-[42px] tracking-[0.25px] text-bbc-brand-700">
                      Dependant&lsquo;s Pass
                    </p>
                    <p className="text-[50px] font-semibold leading-[54px] tracking-[0.25px] text-bbc-brand-700">
                      {AutoConvertPriceWithUnit(800, 1)}
                    </p>
                  </div>
                  <ul className="py-8 px-8">
                    <li className="relative mt-2 list-none">
                      <FaCheck
                        className="absolute top-1.5 left-0 text-bbc-brand-700"
                        size={12}
                      />
                      <span className="inline-block pl-7">
                        Suitable for family members who want to come and stay in
                        Singapore
                      </span>
                    </li>
                  </ul>

                  <div className="border-t px-5 pt-8 pb-11  text-center ">
                    <ButtonNew
                      as="a"
                      href="/onboarding/register"
                      btnColor="bg-bbc-brand-700"
                      othersClass={`${classNames(
                        stylePackage.btnAnimate,
                        stylePackage.btnDarkBlue
                      )} w-full font-normal font-medium `}
                    >
                      <span>Get Started</span>
                    </ButtonNew>
                  </div>
                </div>
              </div>
              <div className="lg:col-8 lg:px-0">
                <i className="mt-6 block rounded-2xl bg-[#F5F5F5] px-4 py-6 text-sm lg:px-10">
                  Your satisfaction is our priority. However, we hope you
                  understand that the final decision on your Employment Pass
                  application approval will be for the Singapore Ministry of
                  Manpower to make.
                </i>
              </div>
            </div>

            <RefundGuarantee className="pt-6 pb-10 lg:mb-20 lg:pt-10" />
          </div>
        </div>
        <div>
          <div className="container">
            <Title className="title-h2 mb-6 text-center  font-semibold text-bbc-brand-800">
              Additional Services
            </Title>
            <p className="mb-6 text-center lg:mb-10">
              Check out BBCIncorp’s extra services for Singapore work pass!
            </p>
            <div className="grid gap-y-4 gap-x-[30px] lg:grid-cols-2 lg:gap-y-10">
              {dataJson.ourServices.map((item, index) => {
                return (
                  <div className="rounded-3xl bg-bbc-white p-6 " key={index}>
                    <div className="">
                      <div className="flex items-center border-b border-bbc-neutral-300 pb-3">
                        <div className="">
                          <Img
                            src={`/assets/icons/${item.icon}`}
                            width={48}
                            height={48}
                            alt="icon"
                            className=" block h-8 w-8 text-center lg:h-12 lg:w-12"
                            wrapper={{
                              className:
                                "bg-bbc-brand-100 flex items-center justify-center rounded-[26px] w-12 lg:w-20 h-12 lg:h-20 text-center",
                            }}
                          />
                        </div>

                        <p className="ml-6 text-lg font-semibold text-bbc-brand-700 lg:text-2xl">
                          {item.title}
                        </p>
                      </div>
                      <div className="pt-3 font-semibold text-bbc-yellow-500">
                        <span className="text-4xl leading-[68px] tracking-[0.25px] lg:text-5xl">
                          {AutoConvertPriceWithUnit(item.price, 1)}
                        </span>
                        <span className="text-base lg:text-lg">
                          {item.suffix}
                        </span>
                      </div>
                      {item.description && (
                        <p className="italic text-bbc-neutral-700">
                          {convertPriceOnString(item.description)}
                        </p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <section className="relative">
        <div className=" absolute hidden h-1/4  w-full bg-bbc-brand-100 md:block"></div>
        <div className="container relative  z-10 pt-10 lg:pt-20">
          <div className="m-auto lg:col-10">
            <FormCountries
              title="Wish to get a hassle-free work pass in Singapore?"
              description="Just get in touch with us. We typically response within 2 hrs."
              descriptionClass="text-left lg:text-center mb-6 lg:mb-10"
              country_id={191}
            />
          </div>
        </div>
        <Img
          src="/assets/images/wave/curve_bot-wave.svg"
          width={1920}
          height={125}
          className="w-full"
          wrapper={{ className: "absolute w-full top-1/4 hidden md:block" }}
          alt="Wave bottom"
        />
      </section>
      <section>
        <div className="container">
          <div className="lg:col-10 lg:mx-auto">
            <Faqs data={dataJson.dataFaqs} />
          </div>
        </div>
      </section>
      <section className="mb-0">
        <div className="container">
          <Title className="title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800">
            Industry News & Insights
          </Title>
          <LazyLoad>
            <NewsSlider data={data} />
          </LazyLoad>
        </div>
      </section>
    </>
  );
};

export default ImmigrationService;
